export default "__VITE_ASSET__DR1dlpIc__"